import styled from 'styled-components';

const ChatListWrapper = styled.div`
  height: 100%;
  position: relative;
  overflow-y: visible;
`;

export const Styled = {
  ChatListWrapper,
};
